import React, { useEffect, useState } from "react";

import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import TextField from "../../Components/Commons/Forms/TextField";
import BtnEdit from "../Commons/Buttons/BtnEdit";
import AntDTable from "../AntDTable/AntDTable";
import DateField from "../Commons/Forms/DateField";
import DeleteModal from "../Modals/DeleteModal";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import InputError from "../InputError/InputError";

import {
  Form,
  Modal,
  Row,
  Col,
  Table as RBSTable,
} from "react-bootstrap";
import { Upload, Button as AntDButton } from "antd";
import {
  createMultipleLabs,
  deleteLabResult,
  getLabResults,
  getLabTests,
  updateLabResult,
} from "../Helpers/API/LabApi/LaboratoryApi";
import {
  formatDate,
  getDateToday,
  getRole,
  getUser,
  validateFileSize,
} from "../Helpers/Utilities/Common";
import {
  isRadiologyResultFormHasNull,
} from "../Helpers/Utilities/Validations/Laboratory";
import { toast } from "react-toastify";
import { UploadOutlined } from "@ant-design/icons";
import { SeeAttachment } from "./SeeAttachment";
import SelectField from "../Commons/Forms/SelectField";
import { getAllDoctors } from "../Helpers/API/DoctorApi/DoctorApi";
import imageCompression from "browser-image-compression";

function Ultrasound(props) {
  const role = getRole();
  const userId = getUser();
  const [addDetails, setAddDetails] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [radiologyTests, setRadiologyTests] = useState([]);
  const [radiologies, setRadiologies] = useState([]);
  const [selectedLabTest, setSelectedLabTest] = useState("");
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctors, setDoctors] = useState([]);

  async function handleAddChange(e, radiolodgy, index, isFile) {
    if (isFile) {
      const attachment = e.target.files[0];
      if (attachment) {
        let fileToUpload = attachment;
        // Compress the image if it exceeds 5MB
        const fileSizeMB = attachment.size / 1024 / 1024;
        if (fileToUpload.type.startsWith("image/") && fileSizeMB > 5) {
          const options = {
            maxSizeMB: 5,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
          };
          const compressedBlob = await imageCompression(fileToUpload, options);

          // Convert blob back to File
          fileToUpload = new File([compressedBlob], attachment.name, {
            type: attachment.type,
            lastModified: Date.now(),
          });
        }

        // Update state with the (possibly compressed) file
        setAddDetails((prevState) => {
          const newState = [...prevState];
          newState[index] = {
            ...newState[index],
            attachments: fileToUpload,
            lab_id: radiolodgy.id,
            lab_test_name: radiolodgy.test
          };
          return newState;
        });
      } else {
        setAddDetails(prevState => {
          const newState = [...prevState];
          if (newState[index]) {
            delete newState[index].attachments; // Only remove the file, not the whole entry
          }
          return newState;
        });
      }
    } else {
      const { name, value } = e.target;

      setAddDetails(prevState => {
        const newState = [...prevState];

        if (!newState[index]) {
          newState[index] = { lab_id: radiolodgy.id, lab_test_name: radiolodgy.test };
        }

        if (value) {
          newState[index] = {
            ...newState[index],
            [name]: value
          };
        } else {
          delete newState[index][name]; // Remove only the specific field, not the whole object


          // If the object is now empty (no fields left), remove it completely
          if (Object.keys(newState[index]).length === 0) {
            newState.splice(index, 1);
          }
        }
        return newState;
      });
    }
  }

  const handleAddDoctorChange = (e) => {
    setSelectedDoctor(e.id);
  };

  const handleEditDoctorChange = (e) => {
    setSelectedRow((prevState) => ({
      ...prevState,
      formattedDoctor: {
        value: e.value, //doctor id
        label: e.label //doctor name
      },
    }));
    setSelectedDoctor(e.id)
  };

  const handleBeforeEditUpload = async (file) => {
    let compressedFile = file;
    const fileSizeMB = file.size / 1024 / 1024;
  
    if (file.type.startsWith("image/") && fileSizeMB > 5) {
        const options = {
          maxSizeMB: 5,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
  
        const compressedBlob = await imageCompression(file, options);
        // Convert the blob into a File and preserve the original name/type
        compressedFile = new File([compressedBlob], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
    }
  
    setSelectedRow((prevState) => ({
      ...prevState,
      attachments: compressedFile,
    }));
    return false; // Prevent auto upload
  };
  
  const handleSave = async () => {
    setIsLoading(true);
    // Filter out entries that have neither result nor attachment
    const filteredDetails = addDetails?.filter(item => {
      const hasResult = item?.result && item.result.trim() !== "";
      const hasAttachment = item?.attachments && item.attachments !== "";
      return hasResult || hasAttachment;
    }) || [];

    const res = await createMultipleLabs({
      patient_id: props.id,
      filteredDetails,
      types: 'radiology',
      selectedDate: selectedDate,
      doctor_id: selectedDoctor
    });

    if (res.data) {
      toast.success(res.data.message);
      fetchUltrasoundResults();
      // props.fetchLaboratoryResult();
      props.showLabForm(false);
    } else if (res.error) {
      res.error.data.messages.forEach((err) => {
        toast.error(err);
      });
    }
    setIsLoading(false);
  };

  const handleEdit = async () => {
    setIsLoading(true);
    const res = await updateLabResult(selectedRow, selectedDoctor);
    if (res.data) {
      toast.success(res.data.message);
      setSelectedRow({});
      setShowEdit(false);
      fetchUltrasoundResults();
    } else if (res.error) {
      res.error.data.messages.forEach((err) => {
        toast.error(err);
      });
    }
    setIsLoading(false);
  };

  const handleDelete = async () => {
    setIsLoading(true);
    const res = await deleteLabResult(selectedRow.id);
    if (res.data) {
      toast.success(res.data.message);
      setSelectedRow({});
      setShowDelete(false);
      fetchUltrasoundResults();
    } else if (res.error) {
      res.error.data.messages.forEach((err) => {
        toast.error(err);
      });
    }
    setIsLoading(false);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setSelectedRow((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function ActionBtn(row) {
    return (
      <Row className="center">
        <Col>
          <BtnSave
            label={"EDIT"}
            size={"sm"}
            onClick={() => {
              setShowEdit(true);
              setSelectedDoctor(row?.row?.doctor_id);
              setSelectedRow(row.row);
            }}
          />
        </Col>
        {
          role === "director" || role === "pcp" || role === "specialist" && (
            <Col>
              <BtnDelete
                outline
                label={"DELETE"}
                size={"sm"}
                onClick={() => {
                  setShowDelete(true);
                  setSelectedRow(row.row);
                }}
              />
            </Col>
          )
        }
      </Row>
    );
  }

  async function fetchUltrasoundTests() {
    const response = await getLabTests({ type: "radiology", sub_type: "ultrasound", with_general: 0 });
    if (response.error) {
      setRadiologies([]);
    } else {
      var data = response.data.data.map((data, index) => {
        var info = data;
        info.lab_index = index;
        info.label = data.lab_name;
        info.value = data.lab_name.replace(/ /g, "_").toLowerCase();
        info.lab_tests = info.lab_tests.map((test) => {
          return {
            ...test,
            value: test.id,
          };
        });
        return data;
      });
      setRadiologies(data);
    }
  }

  async function fetchUltrasoundResults() {
    setShowLoader(true);
    const res = await getLabResults({
      lab_test_type: "radiology",
      lab_test_sub_type: "ultrasound",
      patient_id: props.id,
    });
    if (res.data) {
      var _parsed = res.data.data.map((radiology) => {
        return {
          ...radiology,
          formattedDate: formatDate(radiology.result_date),
          lab_result_attachments: (
            <SeeAttachment attachments={radiology.lab_result_attachments} />
          ),
          attachments: radiology.lab_result_attachments[0],
          formattedDoctor: {
            value: radiology.doctor_id,
            label: radiology.doctor_name
          }
        };
      });
      setData(_parsed);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  // Function for get all doctors API
  async function fetchAllDoctors() {
    const response = await getAllDoctors();
    if (response.data) {
      var data = response.data.data.map((data, index) => {
        var info = data;
        info.label = data.doctor_name;
        info.value = data.id;
        return data;
      });
      setDoctors(data);
    } else {
      setDoctors([]);
    }
  }

  useEffect(() => {
    fetchUltrasoundTests();
    fetchUltrasoundResults();
    fetchAllDoctors();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(role === "nurse" || role === "laboratory"){
      setSelectedDoctor(null)
    } else {
      setSelectedDoctor(userId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  return (
    <div>
      <div className="row">
        <label className="col-6 font-bold mt-2">Ultrasound Results Form</label>
        <p>
          If you cannot find laboratory name, save result in Others section.
        </p>
        <div className="col-sm-3" style={{ zIndex: "11" }}>
        <DateField
          required
          formLabel={`DATE`}
          name='date'
          size={`md`}
          onChange={(e) => setSelectedDate(e.target.value)}
          max={getDateToday()}
        />
      </div>
      {(role === "nurse" || role === "laboratory")  ? (
        <>
          <div className="col-sm-3" style={{ zIndex: "11" }}>
            <SelectField
              required 
              searchable
              formLabel={`ATTENDING PHYSICIAN`}
              name="doctor_id" 
              size={`sm`}
              placeholder={"SELECT"}
              className="dropsearch-filter"
              options={doctors}
              value={doctors.find((doctor) => doctor.value === selectedDoctor) || ""}
              onChange={(e) => handleAddDoctorChange(e)}
            />
          </div>
          <div className="col-3"></div>
        </>
      ) : (
        <>
          <div className="col-6"></div>
        </>
      )}
      <div className="col-sm-3" style={{ zIndex: "11" }}>
          <SelectField
            required 
            searchable
            formLabel={`ULTRASOUND TESTS`}
            name="radiolodgy" 
            size={`sm`}
            placeholder={"SELECT"}
            className="dropsearch-filter"
            options={radiologies}
            onChange={(e) => setSelectedLabTest(e.lab_index)}
          />
        </div>
      </div>
      
      <Row className="ps-3">
      {selectedLabTest !== "" && (
        <RBSTable bordered className="lab-table">
          <thead>
            <tr>
              <th>Lab test</th>
              <th>Result</th>
              {/* <th>Date</th> */}
              <th>File</th>
              {/* <th className="center">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {radiologies[selectedLabTest].lab_tests.map((data, index) => {
              return (
                <tr>
                  <td className="m-0">{`${data.test} ${
                    data.unit !== null || data.unit !== ""
                      ? ""
                      : `(${data.unit})`
                  }`}</td>
                  <td className="m-0">
                    <TextField
                      name='result'
                      value={addDetails[index]?.result}
                      size={`sm`}
                      onChange={(e) =>
                        handleAddChange(e, data, index, false)
                      }
                    />
                  </td>
                  <td className="m-0">
                    <input
                      id={data.id + "_file"}
                      type="file"
                      name={data.id + "_file"}
                      accept=".pdf,image/*"
                      className="form-control date-filter gotham"
                      onChange={(e) =>
                        handleAddChange(e, data, index, true)
                      }
                      disabled={isLoading}
                    />
                    {addDetails[`${data.id}_result`] &&
                      !addDetails[`${data.id}_file`] && (
                        <small className="m-0 p-0 red">*Required</small>
                      )}
                  </td>
                </tr>
              );
            })}
          </tbody>        
        </RBSTable>
      )}
      </Row>

      <Row className="justify-content-end mt-3 mb-3">
        <Col xs={2}>
          <BtnSave
            label={"Submit"}
            size={"sm"}
            onClick={handleSave}
            isClicked={isLoading}
            disabled={
              !selectedDate || 
              isRadiologyResultFormHasNull(addDetails) ||
              !selectedDoctor
            }
          />
        </Col>
      </Row>

      <hr />

      <AntDTable
        tableHeaders={[
          "ULTRASOUND TEST", 
          "RESULT", 
          "ATTACHMENT", 
          "DATE",
          "ATTENDING PHYSICIAN"
        ]}
        headerSelector={[
          "lab_test_name",
          "result",
          "lab_result_attachments",
          "formattedDate",
          "doctor_name"
        ]}
        tableData={data}
        loading={showLoader}
        scroll={{ x: true }}
        isClickable={false}
        ActionBtn={(row) => ActionBtn(row)}
        withAction={true}
      />

      {/* EDIT */}
      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="row">
            <Form.Label className="form-title align-center">
              Edit Ultrasound Result
            </Form.Label>

            <div className="mt-2 mb-2 col-12 align-left">
              Ultrasound: {selectedRow.lab_test_name}
            </div>
          </div>
          <Row>
            <DateField
              required
              className="mt-0"
              id="result_date"
              name="result_date"
              formLabel={`Result Date`}
              size={`sm`}
              onChange={(e) => handleEditChange(e, false)}
              value={selectedRow.result_date}
              errorMessage="Date is required."
              max={getDateToday()}
            />
            <TextField
              // required
              id="result"
              name="result"
              formLabel={`Result`}
              size={`sm`}
              onChange={handleEditChange}
              value={selectedRow.result}
              // errorMessage="Result is required."
            />
          </Row>
          {(role === "nurse" || role === "laboratory") && (
            <>
              <div className="row" style={{ zIndex: "11" }}>
                <SelectField
                    required 
                    searchable
                    formLabel={`Attending Physician`}
                    name="doctor_id" 
                    size={`sm`}
                    placeholder={"SELECT"}
                    className="dropsearch-filter"
                    value={selectedRow.formattedDoctor}
                    options={doctors}
                    onChange={(e) => handleEditDoctorChange(e)}
                  />
              </div>
            </>
          )}
          <Row>
            <Form.Label className="form-label align-left">
              Attachment
            </Form.Label>
            <Upload
              accept=".pdf, image/*"
              maxCount={1}
              defaultFileList={
                selectedRow?.attachments
                  ? [
                      {
                        url: selectedRow?.attachments?.file_url || "",
                        name: selectedRow?.attachments?.file_name || "",
                        status: "done",
                      },
                    ]
                  : []
              }
              beforeUpload={(file) => handleBeforeEditUpload(file)}
              onRemove={(file) => {
                setSelectedRow((prevState) => ({
                  ...prevState,
                  attachments: null,
                }));
              }}
            >
              <AntDButton icon={<UploadOutlined />}>Select File</AntDButton>
              {/* <InputError
                isValid={!selectedRow.attachments}
                message={"Attachment is required."}
              /> */}
            </Upload>
          </Row>
          <Row className="mt-4">
            <Col>
              <BtnDelete
                label="Close"
                onClick={() => setShowEdit(false)}
                isClicked={isLoading}
              />
            </Col>
            <Col>
              <BtnEdit
                disabled={
                  // !selectedRow.result || 
                  !selectedRow.result_date || 
                  (!selectedRow.attachments && !selectedRow.result)
                }
                label="Save changes"
                onClick={handleEdit}
                isClicked={isLoading}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* DELETE */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
        title={`Are you sure you want to delete this ultrasound result?`}
      />
    </div>
  );
}

export default Ultrasound;
